import { ReactNode } from 'react';

import { Link } from 'components/Blocks';
import { ExternalLinkIcon } from 'components/Icons';

interface ProjectLinkProps {
  children?: never;
  id: string;
  text: string | ReactNode;
}

export function ProjectLink({ id, text }: ProjectLinkProps): JSX.Element {
  return (
    <Link
      className="inline-flex items-center gap-2 transition-opacity hover:opacity-65"
      to="projectProfile"
      params={{ projectId: id }}
      target={id}
    >
      {text}

      <ExternalLinkIcon size={16} />
    </Link>
  );
}
